import dayjs from '../../utils/dayjs';

/** Calendar date as ISO 8601 `YYYY-MM-DD`. Null when empty, unparseable, or before 1902. */
export function toDateOnlyIso(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return Number(trimmed.slice(0, 4)) >= 1902 ? trimmed : null;
    }
  }
  const parsed = dayjs(value);
  if (!parsed.isValid() || parsed.year() < 1902) return null;
  return parsed.format('YYYY-MM-DD');
}

/**
 * DateTime fields are not registered on the Ant form (Form.Item name is unset),
 * so onFinish omits them. Draft values from the picker must be merged back in.
 */
export function buildQuickPatientCreatePayload(formValues, draft) {
  const payload = { ...(formValues || {}), ...(draft || {}) };
  if (payload.dateOfBirth !== undefined) {
    payload.dateOfBirth = toDateOnlyIso(payload.dateOfBirth);
  }
  return payload;
}
